// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// third party
import Rails from '@rails/ujs';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'trix';
import 'trix/dist/trix.css';
import '@rails/actiontext';
import '@nu-radd/raincoat';

const allowedTrixAttributes = new Set(['bold', 'italic']);

// Limits the Trix toolbar to only show buttons for allowed attributes
document.addEventListener('trix-initialize', (event) => {
  const toolbar = event.target.toolbarElement;

  if (!toolbar) {
    return;
  }

  toolbar.querySelectorAll('button[data-trix-attribute]').forEach((button) => {
    if (!allowedTrixAttributes.has(button.dataset.trixAttribute)) {
      button.remove();
    }
  });

  toolbar.querySelectorAll('.trix-button-group').forEach((group) => {
    if (!group.querySelector('button[data-trix-attribute]')) {
      group.remove();
    }
  });
});

// internal
function importAll(r) {
  r.keys().forEach(r);
}

importAll(require.context('./config/', true, /.js$/));
importAll(require.context('./css/', true, /.(js|scss)$/));
importAll(require.context('./dialogs/', true, /.js$/));

require.context('../images', true);

import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';
window.Stimulus = Application.start();

import {
  RaincoatIonicBannerController,
  RaincoatIonicCheckboxController
} from '@nu-radd/raincoat';
Stimulus.register('ionic--banner', RaincoatIonicBannerController);
Stimulus.register('ionic--checkbox', RaincoatIonicCheckboxController);

const context = require.context('./controllers', true, /\.js$/);
Stimulus.load(definitionsFromContext(context));
Rails.start();
